import { createRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useRouter } from '@tanstack/react-router'
import { authenticatedRoute } from './_authenticated'
import { openMenuOverlay } from '@/store/slices/uiSlice'
import { resolveLandingRoute } from '@/lib/landing'

/**
 * `/menu` no longer renders a full-screen page (D45b Phase 3) — the Menu
 * overlay (`MenuOverlay`, mounted near the app root) is the real surface
 * now. This route exists only so a direct navigation (a deep link, push
 * notification, or bookmark pointed at `/menu`) still resolves to
 * something instead of 404ing or no-op'ing: it opens the overlay and
 * returns to wherever the member came from.
 */
function MenuRedirect() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const router = useRouter()

  useEffect(() => {
    dispatch(openMenuOverlay())

    // Direct navigation has no in-app history to return to — fall back to
    // today's authenticated landing target (same resolver Phase 1's three
    // redirect sites use) rather than leaving the app via history.back().
    if (window.history.length > 1) {
      router.history.back()
    } else {
      navigate({ to: resolveLandingRoute(true, '/feed'), replace: true })
    }
    // Run once on mount only — this route is a one-shot redirect, not a
    // page that reacts to prop/state changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export const menuRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/menu',
  component: MenuRedirect,
})
